import React from "react";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import { Box } from "@mui/system";

const RoleSelect = ({ isMobile, isColabrotar, roles, onRoleChange, selectedRole }) => {
  return (
    <FormControl
      component="fieldset"
      sx={{
        width: "100%",
        mt: isMobile ? 2 : 0,
      }}
      className="role-radiobox"
    >
      <FormLabel
        className="size-18 weight-600 text-color"
        component="legend"
        sx={{ mb: 1 }}
      >
        Role<span className="star">*</span>
      </FormLabel>
      <RadioGroup
        name="user_role"
        value={selectedRole}
        onChange={(event) => onRoleChange(event.target.value)}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr", // 2 columns
            gap: 1.5,
          }}
        >
          {isColabrotar ? (
            <FormControlLabel
              key={`workflow-option-${roles[1].value}`}
              value={roles[1].value}
              control={<Radio />}
              label={roles[1].label}
            />
          ) : (
            roles.map((option) => (
              <FormControlLabel
                key={`workflow-option-${option.value}`}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))
          )}
        </Box>
      </RadioGroup>
    </FormControl>
  );
};

export default RoleSelect;
